import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, Signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { Project } from 'src/app/interfaces/api/project';
import { ProjectService } from 'src/app/services/api/projects/project.service';
import { ButtonComponent } from 'ui-library';

@Component({
    selector: 'app-timelapse',
    imports: [
        MatToolbarModule,
        CommonModule,
        MatIconModule,
        TranslateModule,
        MatFormFieldModule,
        MatInputModule,
        ButtonComponent,
        ReactiveFormsModule
    ],
    standalone: true,
    templateUrl: './timelapse.component.html',
    styleUrl: './timelapse.component.scss'
})

export class TimeLapseComponent implements OnInit, OnDestroy {
    // Services
    private readonly projectService: ProjectService = inject(ProjectService);
    private readonly formBuilder: FormBuilder = inject(FormBuilder);
    private readonly domSanitizer: DomSanitizer = inject(DomSanitizer);
    private readonly router: Router = inject(Router);

    // Variables
    timelapseGoUrl: SafeResourceUrl = '';
    timelapseGoForm: FormGroup;
    destroy$ = new Subject<void>();
    displayIframe: boolean = false;

    // Signals
    readonly project: Signal<Project | any> = this.projectService.currentProjectSignal;

    constructor() {
        this.timelapseGoForm = this.formBuilder.group({
            box: [''],
            token: ['']
        });
    }

    ngOnInit(): void {
        if (this.project && this.project().timelapseGo) {
            const url = `https://prod.timelapsego.com/embed/company/box/${this.project().timelapseGo.box}/fs?accesstoken=${this.project().timelapseGo.token}`;
            this.timelapseGoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);

            this.timelapseGoForm.patchValue({
                box: this.project().timelapseGo.box,
                token: this.project().timelapseGo.token
            });
        }
    }

    openProjectSettings() {
        this.router.navigate(['/project/project-settings/informations']);
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    // onSubmit() {
    //     const boxValue = this.timelapseGoForm.value.box;
    //     const tokenValue = this.timelapseGoForm.value.token;

    //     if (!this.project.timelapseGo) {
    //         this.project.timelapseGo = { box: boxValue, token: tokenValue };
    //     } else {
    //         this.project.timelapseGo.box = boxValue;
    //         this.project.timelapseGo.token = tokenValue;
    //     }

    //     this.projectService.setProject(this.project).pipe(takeUntil(this.destroy$)).subscribe({
    //         next: () => {
    //             console.log('Project updated successfully');
    //             this.displayIframe = true;
    //             this.ngOnInit();
    //         },
    //         error: (err) => {
    //             console.error('Error updating project:', err);
    //             this.pop.error('Invalid credentials');
    //             this.displayIframe = false;
    //         }
    //     });
    // }
}
